import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import '@/App.css';

import PublicHome from '@/pages/PublicHome';
import AdminLogin from '@/pages/AdminLogin';
import AdminLayout from '@/pages/AdminLayout';
import AdminOverview from '@/pages/AdminOverview';
import AdminServices from '@/pages/AdminServices';
import AdminContent from '@/pages/AdminContent';
import AdminContentStudio from '@/pages/AdminContentStudio';
import AdminMessages from '@/pages/AdminMessages';
import AdminBookings from '@/pages/AdminBookings';
import AdminSettings from '@/pages/AdminSettings';
import AdminClients from '@/pages/AdminClients';
import AdminCalendar from '@/pages/AdminCalendar';
import AdminInvoices from '@/pages/AdminInvoices';
import AdminAnalytics from '@/pages/AdminAnalytics';
import { isAuthed } from '@/lib/auth';

const RequireAuth = ({ children }) => {
  if (!isAuthed()) return <Navigate to="/admin/login" replace />;
  return children;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<PublicHome />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin"
          element={
            <RequireAuth>
              <AdminLayout />
            </RequireAuth>
          }
        >
          <Route index element={<Navigate to="/admin/overview" replace />} />
          <Route path="overview" element={<AdminOverview />} />
          <Route path="analytics" element={<AdminAnalytics />} />
          <Route path="calendar" element={<AdminCalendar />} />
          <Route path="clients" element={<AdminClients />} />
          <Route path="invoices" element={<AdminInvoices />} />
          <Route path="bookings" element={<AdminBookings />} />
          <Route path="messages" element={<AdminMessages />} />
          <Route path="services" element={<AdminServices />} />
          <Route path="content" element={<AdminContentStudio />} />
          <Route path="settings" element={<AdminSettings />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster position="top-right" richColors closeButton />
    </BrowserRouter>
  );
}

export default App;
